/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {createSelector} from 'reselect';
import {
  Notification
} from '@ion/dls/src/types/extensions';
import {
  NotificationPanelTabs
} from '@ion/dls/src/types/types';
import {PanelState} from '@/store/reducers/notifications';

// input selectors ...
const selectIsLoading = ({notifications}) => notifications.loading;
const selectAllNotifications = ({notifications}) => notifications.all;
const selectUrgentNotifications = ({notifications}) => notifications.urgent;
const selectLatestNotifications = ({notifications}) => notifications.latest;
const selectUnreadCount = ({notifications}) => notifications.unreadCount;
const selectIsRefreshing = ({notifications}) => notifications.refreshing;
const selectIsUpdating = ({notifications}) => notifications.updating;
const selectIsLoadingDetails = ({notifications}) => notifications.loadingDetails;
const selectNotificationsPanel = ({notifications}) => notifications.panel;

// output selectors ...
export const isLoadingSelector = createSelector(selectIsLoading,
  (isLoading: boolean): boolean => isLoading
);

export const allNotificationsSelector = createSelector(selectAllNotifications,
  (all: Notification): Notification => all
);

export const urgentNotificationsSelector = createSelector(selectUrgentNotifications,
  (urgent: Notification): Notification => urgent
);

export const latestNotificationsSelector = createSelector(selectLatestNotifications,
  (latest: Notification): Notification => latest
);

export const unreadCountSelector = createSelector(selectUnreadCount,
  (unreadCount: number): number => unreadCount
);

export const isRefreshingSelector = createSelector(selectIsRefreshing,
  (isRefreshing: boolean): boolean => isRefreshing
);

export const isUpdatingSelector = createSelector(selectIsUpdating,
  (isUpdating: boolean): boolean => isUpdating
);

export const isLoadingDetailsSelector = createSelector(selectIsLoadingDetails,
  (isLoadingDetails: boolean): boolean => isLoadingDetails
);

export const activePanelSelector = createSelector(selectNotificationsPanel,
  (panel: any): NotificationPanelTabs => panel.activePanel
);

export const isPanelOpenSelector = createSelector(selectNotificationsPanel,
  (panel: any): boolean => panel.open
);

export const panelStateSelector = createSelector(selectNotificationsPanel,
  (panel: any): PanelState[] => panel.state
);

export const selectedNotificationsSelector = createSelector(selectNotificationsPanel,
  (panel: any): Notification[] => panel.selected
);
